import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const fonts = {
  heading: `SUIT Variable, sans-serif`,
  body: `SUIT Variable, sans-serif`,
};

const colors = {
  mint: {
    500: '#5bbca6',
  },
  black_button: {
    500: '#000000',
  },
};

const theme = extendTheme({ config, fonts, colors });

export default theme;
